"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, CircleCheck, ShieldCheck } from "lucide-react";
export default function HeroProductosGrandstream() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imagesRef,
    isVisible: areImagesVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-productos-grandstream" className="bg-background">
      {}
      <div className="dark bg-background text-foreground py-20 lg:py-32 relative overflow-hidden">
        {}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/20 via-background to-background pointer-events-none"></div>

        <div className="container mx-auto px-4 md:px-6 relative z-10">
          <div ref={headerRef} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="flex flex-wrap justify-center gap-3 mb-6">
              <Badge variant="secondary" className="px-4 py-1.5 text-sm bg-secondary/20 text-secondary-foreground border border-secondary/30">PREGUNTENOS, MEJORAMOS CUALQUIER PRECIO POR ESCRITO</Badge>
              <Badge variant="outline" className="px-4 py-1.5 text-sm border-border/50 bg-background/50 backdrop-blur-sm"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-shield-check w-4 h-4 mr-2 text-primary" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path><path d="m9 12 2 2 4-4"></path></svg>SOMOS UN PARTNER CON LA MÁS ALTA CERTIFICACIÓN</Badge>
            </div>
            
            <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6">
              PRODUCTOS <span className="text-primary">GRANDSTREAM</span>
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
              Soluciones completas de comunicaciones unificadas y redes. Equipamiento profesional con disponibilidad inmediata para potenciar la conectividad y productividad de su empresa.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button size="lg" asChild className="w-full sm:w-auto group">
                <Link to="/GrandstreamCentralPage">SOMOS LOS PRIMEROS EN COSTA RICA VENDIENDO GRANDSTREAM, ESO CUENTA!<ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" /></Link>
              </Button>
              <Button size="lg" variant="outline" asChild className="w-full sm:w-auto bg-transparent border-border hover:bg-accent hover:text-accent-foreground">
                <Link to="#">LLAMANOS O CHATEA!</Link>
              </Button>
            </div>
          </div>

          <div ref={imagesRef} className={`mt-16 md:mt-24 grid grid-cols-1 gap-8 transition-all duration-1000 delay-300 ${areImagesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="rounded-2xl overflow-hidden border border-border/50 shadow-2xl shadow-black/50 group relative bg-card bg-muted">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/GrandstreamRedes.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/GrandstreamRedes.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/GrandstreamRedes.png-wvc-sizes" alt="Catálogo de Redes Grandstream" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" width="1200" height="900" decoding="async" />
                <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/40 to-transparent flex flex-col justify-end p-6 md:p-8">
                  <div className="transform transition-transform duration-500 group-hover:-translate-y-2">
                    <h3 className="font-default text-2xl md:text-3xl font-bold text-foreground mb-2">Networking</h3>
                    <p className="text-muted-foreground text-sm md:text-base">Switches, Routers y Puntos de Acceso Wi-Fi de alto rendimiento.</p>
                  </div>
                </div>
              </AspectRatio>
            </div>

            {}
            <div className="rounded-2xl overflow-hidden border border-border/50 shadow-2xl shadow-black/50 group relative bg-card bg-muted">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/Grandstream.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/Grandstream.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/Grandstream.png-wvc-sizes" alt="Línea de Teléfonos IP Grandstream" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" width="1200" height="900" decoding="async" />
                <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/40 to-transparent flex flex-col justify-end p-6 md:p-8">
                  <div className="transform transition-transform duration-500 group-hover:-translate-y-2">
                    <h3 className="font-default text-2xl md:text-3xl font-bold text-foreground mb-2">Telefonía IP</h3>
                    <p className="text-muted-foreground text-sm md:text-base">Teléfonos IP, Videoteléfonos y sistemas de Audioconferencia.</p>
                  </div>
                </div>
              </AspectRatio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}